var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .001h6.753v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.623 0h6.754v20H.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.245 0H7v20H.245z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.074 6.277c-.628.877-1.9 1.112-2.836.526s-1.188-1.78-.56-2.656a2.038 2.038 0 011.3-.814 2.14 2.14 0 011.533.288 1.9 1.9 0 01.869 1.22 1.8 1.8 0 01-.305 1.436m1.613-1.68c-.176-.83-.685-1.545-1.435-2.015a3.499 3.499 0 00-1.224-.475c.003-.018.015-.03.015-.05V.444c0-.245-.3-.444-.667-.444S2.7.2 2.7.444v1.61c0 .02.012.032.015.05h-.007a3.382 3.382 0 00-2.15 1.344c-1.033 1.45-.617 3.423.928 4.39.38.238.793.365 1.215.444v11.103c0 .34.297.613.667.613s.667-.274.667-.613V8.3c.843-.16 1.623-.607 2.14-1.328.5-.704.68-1.547.505-2.377",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.302 13.723c.628-.877 1.9-1.112 2.836-.526s1.188 1.78.56 2.656a2.038 2.038 0 01-1.3.814 2.14 2.14 0 01-1.533-.288 1.9 1.9 0 01-.869-1.22 1.8 1.8 0 01.305-1.436M.69 15.404c.176.83.685 1.545 1.435 2.015.376.236.792.395 1.224.475-.003.017-.015.03-.015.05v1.61c0 .245.3.444.667.444s.667-.2.667-.444v-1.61c0-.02-.01-.033-.015-.05h.007a3.382 3.382 0 002.15-1.344c1.033-1.45.617-3.423-.928-4.39-.38-.238-.793-.365-1.215-.444V.612C4.667.272 4.37 0 4 0s-.667.274-.667.612V11.7c-.84.16-1.62.607-2.14 1.328-.5.704-.68 1.547-.505 2.377",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.32 10.23a2.04 2.04 0 01-1.3.814 2.06 2.06 0 01-.315.029c-.028-.004-.053-.015-.083-.015s-.056.012-.087.016a2.151 2.151 0 01-1.05-.317 1.9 1.9 0 01-.868-1.22A1.81 1.81 0 011.924 8.1h.001a2.038 2.038 0 011.3-.814c.132-.025.268-.038.4-.038.4 0 .792.1 1.132.325.455.285.76.716.868 1.22s-.001 1.013-.307 1.438m1.615-1.68c-.175-.83-.685-1.544-1.433-2.014a3.48 3.48 0 00-1.21-.477V.612C4.3.273 3.99 0 3.623 0s-.667.274-.667.612v5.45c-.88.166-1.64.643-2.14 1.34S.135 8.95.31 9.78s.685 1.544 1.433 2.015c.372.23.785.36 1.212.443v7.15c0 .34.297.61.667.61s.667-.273.667-.61v-7.122a3.382 3.382 0 002.14-1.34c.503-.704.683-1.55.507-2.378",
    mask: "url(#f)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.615a1c81f5d82374155f75517cdadb59.svg";
export { ForwardRef as ReactComponent };